const LOCAL_STORAGE_TYPES = {
    restart: 'restart',
    isGettingStart: 'isGettingStart',
    autoRefreshTimeout: 'autoRefreshTimeout',
}

export {
    LOCAL_STORAGE_TYPES,
}
